import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleCustomerModal } from '../../../redux/actions/customerActions';
export const companyManagementDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createCompany',
        popover: {
          title: 'Create a New Company',
          description:
            'Use this option to add a new company to your management system. Fill in the required details to register the company in the database.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.activeCompanies',
        popover: {
          title: 'View Active Companies',
          description:
            'This section displays all currently active companies. You can manage these companies, update their details, or deactivate them if necessary.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allCompanies',
        popover: {
          title: 'All Companies Overview',
          description:
            'Here you can view and manage all companies, both active and inactive. This overview helps you keep track of every company in the system.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.companyManagementMainTable',
        popover: {
          title: 'Company Management Table',
          description:
            'This table provides a detailed view of all companies under your management. You can edit, update, or delete company records from here.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleCustomerModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default companyManagementDriverObj;
